import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteAcCategoryData, getAcCategoryDatas,} from "../../../redux/modules/AcCategory/action";

class AcCategory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getAcCategoryDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.acCategory.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const acCategoryColumn = [
            {
                name: "Access Category",
                path: "name",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"Access Category Data"}
                        data={this.props.acCategory.datas}
                        columns={acCategoryColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteAcCategoryData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    acCategory: state.acCategory,
});

const mapDispatchToProps = {
    getAcCategoryDatas,
    deleteAcCategoryData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AcCategory)
);
